import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import DjProfile from './pages/DjProfile';
import RequestPage from './pages/RequestPage';
import Dashboard from './pages/Dashboard';
import EventManagement from './pages/EventManagement';
import ProfileSettings from './pages/ProfileSettings';
import Subscription from './pages/Subscription';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ReferralPage from './pages/ReferralPage';
import PrivateRoute from './utils/PrivateRoute';
import EventDetails from './pages/EventDetails';
import { getCurrentUser } from './services/auth';
import { getUserProfile } from './services/api';


import './App.css';

function App() {
  const { t } = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [user, setUser] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const location = useLocation();


    useEffect(() => {
        const currentUser = getCurrentUser();
        if (currentUser) {
            setIsAuthenticated(true);
            getUserProfile()
                .then(res => {
                    setUser(res.data)
                })
                .catch(() => setUser(null));
        }
        setIsLoading(false);
    }, [location]);


    if (isLoading) {
    return <div className="loading-spinner">{t('loading')}</div>;
  }

  return (
    <div className="app-container">
        <Navbar
            isAuthenticated={isAuthenticated}
            setIsAuthenticated={setIsAuthenticated}
            user={user}
        />

        <main className="main-content">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/dj/:username" element={<DjProfile />} />
          <Route path="/request/:eventId" element={<RequestPage />} />
          <Route path="/login" element={<LoginPage setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/signup" element={<SignupPage setIsAuthenticated={setIsAuthenticated} />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/events"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <EventManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <ProfileSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Subscription />
              </PrivateRoute>
            }
          />
            <Route
                path="/referral"
                element={
                    <PrivateRoute isAuthenticated={isAuthenticated}>
                        <ReferralPage />
                    </PrivateRoute>
                }
            />


            <Route path="/dashboard/event/details/:eventId" element={<EventDetails />} />

          {/* Redirect to home if route not found */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
